var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "return-request-dialog",
      attrs: {
        fullscreen: true,
        "close-on-press-escape": false,
        "show-close": false,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "return-request-title-bar",
          attrs: { id: "return-request-title" },
        },
        [
          !_vm.showFinalStep
            ? _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  staticStyle: { right: "unset", left: "20px" },
                  attrs: { type: "button", "aria-label": "Back" },
                  on: { click: _vm.back },
                },
                [
                  _c("i", {
                    staticClass: "el-dialog__close el-icon el-icon-arrow-left",
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "order-number" }, [
            _vm._v(
              "\n      Return for order #" +
                _vm._s(
                  _vm.order.order.displayable_order_id ||
                    _vm.order.order.order_id
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "el-dialog__headerbtn",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("update:visible", false)
                },
              },
            },
            [_c("i", { staticClass: "el-dialog__close el-icon el-icon-close" })]
          ),
          _vm._v(" "),
          _c("StepProgressBar", {
            attrs: {
              "total-steps": _vm.totalSteps,
              "current-step": _vm.currentStep,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "return-request-body",
              attrs: { id: "return-request-body" },
            },
            [
              _c(
                "div",
                { staticClass: "return-request-steps" },
                [
                  _vm.showInstallationWarning
                    ? _c(
                        "el-alert",
                        {
                          staticStyle: { "margin-bottom": "16px" },
                          attrs: {
                            title: "Installation Service — Do Not Return",
                            type: "warning",
                            closable: false,
                            "show-icon": "",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n          Do not process returns on the Installation ASIN (IG-5X-601-PIN).\n          Check your resources for guidance or reach out to leadership.\n        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("StepFlowButton", {
                    attrs: {
                      buttontext: "Step 1: Select Items",
                      isactive: _vm.isactive1,
                      "current-value": 1,
                      disabled: _vm.isdisabled1,
                    },
                    on: { "go-back": _vm.previous },
                  }),
                  _vm._v(" "),
                  _c("StepFlowButton", {
                    attrs: {
                      buttontext: "Step 2: Customer Details",
                      isactive: _vm.isactive2,
                      "current-value": 2,
                      disabled: _vm.isdisabled2,
                    },
                    on: { "go-back": _vm.previous },
                  }),
                  _vm._v(" "),
                  _c("StepFlowButton", {
                    attrs: {
                      buttontext: "Step 3: Send return label",
                      isactive: _vm.isactive3,
                      "current-value": 3,
                      disabled: _vm.isdisabled3,
                    },
                    on: { "go-back": _vm.previous },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "return-request-data",
                  attrs: { id: "return-request-data" },
                },
                [
                  _vm.currentStep === 1
                    ? _c("ReturnSelectItems", {
                        attrs: {
                          loading: _vm.loading,
                          "returnable-items": _vm.returnableItems,
                          "already-selected": _vm.allItemsWithAlreadySelected,
                          "return-reasons": _vm.returnReasons,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                          "get-selected-items-for-return":
                            _vm.setSelectedItemsForReturn,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2 && !_vm.isEditDetailsStep
                    ? _c("ReviewCustomerDetails", {
                        attrs: {
                          loading: _vm.loading,
                          "edit-details": _vm.isEditDetailsStep,
                          "refund-payment-info": _vm.refundPaymentInfo,
                          "refund-info": _vm.refundInfo,
                          customer: _vm.customerDetails,
                          address: _vm.address,
                          "addtional-fees": _vm.additionalFees,
                          "total-tax": _vm.totalTax,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                          "update:editDetails": function ($event) {
                            _vm.isEditDetailsStep = $event
                          },
                          "update:edit-details": function ($event) {
                            _vm.isEditDetailsStep = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 2 && _vm.isEditDetailsStep
                    ? _c("EditCustomerDetails", {
                        ref: "editCustomer",
                        attrs: {
                          allvalid: _vm.editCustomerEnableSave,
                          customer: _vm.customerDetails,
                          address: _vm.address,
                          edited: _vm.isEdited,
                        },
                        on: {
                          "update:allvalid": function ($event) {
                            _vm.editCustomerEnableSave = $event
                          },
                          "update:customer": function ($event) {
                            _vm.customerDetails = $event
                          },
                          "update:address": function ($event) {
                            _vm.address = $event
                          },
                          "update:edited": function ($event) {
                            _vm.isEdited = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 3 && !_vm.showFinalStep
                    ? _c("ReviewReturnSummary", {
                        attrs: {
                          loading: _vm.loading,
                          "refund-payment-info": _vm.refundPaymentInfo,
                          "refund-info": _vm.refundInfo,
                          customer: _vm.customerDetails,
                          address: _vm.address,
                          "items-to-return": _vm.flattenedItemsToReturn,
                          "needs-return-label": _vm.needsReturnLabel,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStep === 3 && _vm.showFinalStep
                    ? _c("ReturnSummary", {
                        attrs: {
                          loading: _vm.loading,
                          "refund-payment-info": _vm.refundPaymentInfo,
                          "refund-info": _vm.refundInfo,
                          customer: _vm.customerDetails,
                          address: _vm.address,
                          "return-id": _vm.returnId,
                          "items-to-return": _vm.flattenedItemsToReturn,
                          "needs-return-label": _vm.needsReturnLabel,
                        },
                        on: {
                          "update:loading": function ($event) {
                            _vm.loading = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "return-request-footer",
          attrs: { id: "return-request-footer" },
        },
        [
          _vm.showReturnSummaryConfirmationLink
            ? _c(
                "el-checkbox",
                {
                  staticClass: "confirm-checkbox",
                  staticStyle: { "margin-right": "24px" },
                  model: {
                    value: _vm.isSummaryConfirmed,
                    callback: function ($$v) {
                      _vm.isSummaryConfirmed = $$v
                    },
                    expression: "isSummaryConfirmed",
                  },
                },
                [
                  _vm._v(
                    "\n      The items for return and address are correct.\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showEditAddressConfirmationCheck
            ? _c(
                "el-checkbox",
                {
                  staticClass: "confirm-checkbox",
                  staticStyle: { "margin-right": "24px" },
                  model: {
                    value: _vm.isEditConfirmed,
                    callback: function ($$v) {
                      _vm.isEditConfirmed = $$v
                    },
                    expression: "isEditConfirmed",
                  },
                },
                [
                  _vm._v(
                    "\n      Customer details and address are correct.\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showBack
            ? _c(
                "el-button",
                { staticClass: "action_button back", on: { click: _vm.back } },
                [_vm._v("\n      Back\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCancel
            ? _c(
                "el-button",
                {
                  staticClass: "action_button back",
                  on: { click: _vm.cancel },
                },
                [_vm._v("\n      Cancel\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showNext
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: { type: "primary", disabled: _vm.isNextDisabled },
                  on: { click: _vm.next },
                },
                [_vm._v("\n      Next\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSaveChanges,
                  expression: "showSaveChanges",
                },
              ],
              staticClass: "action_button",
              attrs: {
                type: "primary",
                disabled: !_vm.isEditConfirmed || !_vm.editCustomerEnableSave,
              },
              on: { click: _vm.saveChanges },
            },
            [_vm._v("\n      Save Changes\n    ")]
          ),
          _vm._v(" "),
          _vm.currentStep == 3 && !_vm.showFinalStep
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: {
                    type: "primary",
                    disabled: _vm.isSendReturnLabelDisabled,
                  },
                  on: { click: _vm.finalStep },
                },
                [_vm._v("\n      Send Return Label\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStep == 3 && _vm.showFinalStep
            ? _c(
                "el-button",
                {
                  staticClass: "action_button",
                  attrs: { type: "primary" },
                  on: { click: _vm.exit },
                },
                [_vm._v("\n      Done\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }